import Axios from "axios";
const url_api = process.env.VUE_APP_API_URL;
const url_ipInfo = process.env.VUE_APP_IPINFO_URL;

export function getUser(token) {
  return Axios.get(url_api + "/api/auth/user", {
    headers: {
      'Access-Control-Allow-Origin': '*',
      Authorization: "bearer " + token
    }
  });
}

export function postRegister(data) {
  return Axios.post(url_api + "/api/auth/register", data);
}

export function postLogin(data) {
  return Axios.post(url_api + "/api/auth/login", data);
}

export function postForgotPassword(data) {
  return Axios.post(url_api + "/api/auth/forgot-password", data);
}

export function postResetPassword(data) {
  return Axios.post(url_api + "/api/auth/reset-password", data);
}

export function validateCaptha(data) {
  return Axios.post(url_api + "/api/validate_captcha", data);
}

export function getIP() {
  return Axios.post(url_api + "/api/users/get_pi");
}

export function getIpInfo() {
  return Axios.get(url_ipInfo);
}